module.exports = "https://health.dajiuxing.com.cn/img/assets/img/turntable_go.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fimg%2Fturntable_go.png
// module id = 7u4b
// module chunks = 93